import React, { useEffect, useState } from "react";
import "../styles/loading.css";

export function LoadingPage() {
    const [isLeaving, setIsLeaving] = useState(false);
    const [shouldRender, setShouldRender] = useState(true);

    useEffect(() => {
        // Start the exit animation at 5.4s (when the loading bar completes)
        const exitTimeout = setTimeout(() => {
            setIsLeaving(true);
        }, 5400);

        // Fully unmount the component at 6.0s (after the 0.6s css transition completes)
        const unmountTimeout = setTimeout(() => {
            setShouldRender(false);
        }, 6000);

        return () => {
            clearTimeout(exitTimeout);
            clearTimeout(unmountTimeout);
        };
    }, []);

    if (!shouldRender) return null;

    return (
        <div className={`loading-screen-overlay ${isLeaving ? "is-leaving" : ""}`}>
            {/* Ambient Background Glows */}
            <div className="ambient-glow-1"></div>
            <div className="ambient-glow-2"></div>

            <div className="loading-content-container">
                {/* SVG Animated Brand Mark */}
                <div className="logo-svg-wrapper">
                    <svg className="logo-svg" viewBox="0 0 140 140">
                        <defs>
                            {/* Gradients */}
                            <linearGradient id="cyanBlueGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#00f2fe" />
                                <stop offset="100%" stopColor="#4facfe" />
                            </linearGradient>
                            <linearGradient id="burgundyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#9a0000" />
                                <stop offset="100%" stopColor="#700000" />
                            </linearGradient>
                            <radialGradient id="lensGlassGrad" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#00f2fe" stopOpacity="0.8" />
                                <stop offset="70%" stopColor="#700000" stopOpacity="0.3" />
                                <stop offset="100%" stopColor="#000015" stopOpacity="0.9" />
                            </radialGradient>
                            <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                                <feGaussianBlur stdDeviation="4" result="blur" />
                                <feComposite in="SourceGraphic" in2="blur" operator="over" />
                            </filter>
                        </defs>

                        {/* Outer Lens Ring (Rotates Clockwise) */}
                        <circle cx="70" cy="70" r="55" className="lens-outer-ring" />

                        {/* Inner Lens Ring (Rotates Counter-Clockwise) */}
                        <circle cx="70" cy="70" r="38" className="lens-inner-ring" />

                        {/* Glowing Glass Lens Center */}
                        <circle cx="70" cy="70" r="18" fill="url(#lensGlassGrad)" className="lens-glass-center" />

                        {/* Aperture Blades (Rotates Clockwise) */}
                        <g className="lens-blades-group">
                            <path d="M 70 15 L 88 32" className="lens-aperture-blade" />
                            <path d="M 125 70 L 108 88" className="lens-aperture-blade" />
                            <path d="M 70 125 L 52 108" className="lens-aperture-blade" />
                            <path d="M 15 70 L 32 52" className="lens-aperture-blade" />
                            
                            <path d="M 108 32 L 108 55" className="lens-aperture-blade" />
                            <path d="M 108 108 L 85 108" className="lens-aperture-blade" />
                            <path d="M 32 108 L 32 85" className="lens-aperture-blade" />
                            <path d="M 32 32 L 55 32" className="lens-aperture-blade" />
                        </g>

                        {/* Air Flow Waves representing Heating & Cooling (across center) */}
                        <path 
                            d="M 10 64 C 40 44, 50 84, 80 64 C 110 44, 115 74, 130 64" 
                            className="airflow-wave-cool" 
                            filter="url(#glow)"
                        />
                        <path 
                            d="M 10 76 C 40 96, 50 56, 80 76 C 110 96, 115 66, 130 76" 
                            className="airflow-wave-warm" 
                            filter="url(#glow)"
                        />
                    </svg>
                </div>

                {/* Brand Name Text with fade & slide animation */}
                <div className="brand-title-wrapper">
                    <h1 className="brand-title-text">Jamas Lens</h1>
                </div>

                {/* Subtitle */}
                <h2 className="brand-subtitle-text">Climatisation & Construction</h2>

                {/* Loader Bar */}
                <div className="progress-bar-container">
                    <div className="progress-bar-fill"></div>
                </div>
            </div>
        </div>
    );
}
